import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { ReactComponent as Checked } from '../../../assets/svg/Checked.svg';
import Button from '../../../components/mplat/Button/Button';
import { CheckBox } from '../../../components/mplat/CheckBox';

interface FixedButtonGroupProps {
    checked: boolean,
    sendProviderReport: boolean,
    setSendProviderReport: React.Dispatch<React.SetStateAction<boolean>>,
    onSave: (event: React.MouseEvent<HTMLElement, MouseEvent>, setAction: (v: boolean) => void, withApprove?: boolean) => Promise<void>,
    hasChanges: boolean,
}

export function FixedButtonGroup({ onSave, sendProviderReport, setSendProviderReport, checked, hasChanges }: FixedButtonGroupProps) {
    const { t } = useTranslation();

    const [inAction, setIsAction] = useState(false);

    const { ref, inView } = useInView({
        threshold: 0.5
    });

    return (
        <>
            <div ref={ref} className="content-add__submit-mod">
                <span className={'btn content-add__submit-mod-approve' + ((inAction || !checked) ? ' _disabled' : '')} onClick={(e) => !(inAction || !checked) && onSave(e, setIsAction, true)}>
                    <span className="btn__icon _left">
                        <Checked style={{ width: '15px', height: '11px' }} />
                        {' '}
                        <Trans>Approve card</Trans>
                    </span>
                </span>
                <div className="content-add__submit-mod-save">
                    <p className="content-add__submit-mod-save-sent">
                        <CheckBox value={sendProviderReport} label={t('component:CONTENT_SEND_REPORT')} style={{lineHeight: '2px'}} onChange={(v) => setSendProviderReport(v)} />
                    </p>
                    <Button
                        type="submit"
                        className="content-add__submit-mod-save-btn"
                        disabled={inAction || !hasChanges}
                        onClick={(e) => onSave(e, setIsAction)}
                    >
                        <Trans>Save</Trans>
                    </Button>
                </div>
            </div>
            <div className={'content-add__submit-mod-fixed' + (inView ? '' : ' _active')}>
                <span className={'btn content-add__submit-mod-approve' + ((inAction || !checked) ? ' _disabled' : '')} onClick={(e) => !(inAction || !checked) && onSave(e, setIsAction, true)}>
                    <span className="btn__icon _left">
                        <Checked style={{ width: '15px', height: '11px' }} />
                        {' '}
                        <Trans>Approve card</Trans>
                    </span>
                </span>
                <span className={'btn content-add__submit-mod-save-btn' + ((inAction || !hasChanges) ? ' _disabled' : '')} onClick={(e) => onSave(e, setIsAction)}>
                    <Trans>Save</Trans>
                </span>
            </div>
        </>
    );
}